import { Menu } from "antd";
import { Children, useEffect, useState } from "react";

import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import {
  AiOutlineUnlock,
  AiOutlineUsergroupAdd,
  AiOutlineDropbox,
  AiOutlineShoppingCart,
  AiOutlineMenuFold,
  AiOutlinePercentage,
  AiFillShop,
  AiOutlineStock,
  AiOutlineStar,
  AiOutlineFileSearch,
  AiOutlineDatabase,
} from "react-icons/ai";
import {
  BiCategoryAlt,
  BiNews,
  BiExtension,
  BiFileBlank,
} from "react-icons/bi";
import { BsImages, BsNewspaper } from "react-icons/bs";
import { HiSpeakerphone } from "react-icons/hi";
import {
  FaRegCreditCard,
  FaTruck,
  FaBullhorn,
  FaGlobe,
  FaSitemap,
} from "react-icons/fa";

import { useSelector } from "react-redux";
import PERMISSION from "../../consts/permissions";
import { MdTitle } from "react-icons/md";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const SubMenu = Menu.SubMenu;

  const { permissions } = useSelector((x) => x.auth);
  const [listPermissions, setPermissions] = useState(permissions);

  // useEffect(() => {
  //   setPermissions(permissions);
  // }, [permissions]);

  const dashboard = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
        fill={color}
      ></path>
      <path
        d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
        fill={color}
      ></path>
      <path
        d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const profile = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
        fill={color}
      ></path>
    </svg>,
  ];

  return (
    <>
      <div className="brand" style={{ textAlign: "center" }}>
        <img src={logo} alt="" />
        {/* <span>VN-FARM</span> */}
      </div>
      <hr />
      <Menu
        theme="light"
        mode="inline"
        // defaultOpenKeys={["catalog", "product-page", "article-page"]}
      >
        <Menu.Item key="dashboard">
          <NavLink to="/dashboard">
            <span
              className="icon"
              style={{
                background: page === "dashboard" ? color : "",
              }}
            >
              {dashboard}
            </span>
            <span className="label">Dashboard</span>
          </NavLink>
        </Menu.Item>
        <Menu.SubMenu
          className="menu-item-header"
          key="catalog"
          title={<label>Catalog</label>}
        >
          {/* <Menu.Item className="menu-item-header" key="Catalog">
          Catalog
        </Menu.Item> */}

          {listPermissions.includes(PERMISSION.Admin_Order_View) ? (
            <Menu.Item key="order">
              <NavLink to="/order">
                <span
                  className="icon"
                  style={{
                    background: page === "order" ? color : "",
                  }}
                >
                  <AiOutlineShoppingCart />
                </span>
                <span className="label">Đơn hàng</span>
              </NavLink>
            </Menu.Item>
          ) : null}

          {/* {listPermissions.includes(PERMISSION.Admin_Report_View) ? (
            <Menu.Item key="reports">
              <NavLink to="/reports">
                <span
                  className="icon"
                  style={{
                    background: page === "reports" ? color : "",
                  }}
                >
                  <AiOutlineStock />
                </span>
                <span className="label">Báo cáo</span>
              </NavLink>
            </Menu.Item>
          ) : null} */}

          {listPermissions.includes(PERMISSION.Admin_Review_View) ? (
            <Menu.Item key="review">
              <NavLink to="/review">
                <span
                  className="icon"
                  style={{
                    background: page === "review" ? color : "",
                  }}
                >
                  <AiOutlineStar />
                </span>
                <span className="label">Đánh giá</span>
              </NavLink>
            </Menu.Item>
          ) : null}
          {listPermissions.includes(PERMISSION.Admin_Transaction_View) ? (
            <Menu.Item key="logs">
              <NavLink to="/logs">
                <span
                  className="icon"
                  style={{
                    background: page === "logs" ? color : "",
                  }}
                >
                  <AiOutlineDatabase />
                </span>
                <span className="label">Logs giao dịch</span>
              </NavLink>
            </Menu.Item>
          ) : null}
        </Menu.SubMenu>

        {/* {listPermissions.includes("Admin.UserCustomer.View") ? (
          <Menu.Item className="menu-item-header" key="customer">
            Khách hàng
          </Menu.Item>
        ) : null} */}

        <Menu.SubMenu
          className="menu-item-header"
          key="product-page"
          title={<label> Sản phẩm</label>}
        >
          {/* {listPermissions.includes("Admin.Product.View") ? (
          <Menu.Item className="menu-item-header" key="4">
            Sản phẩm
          </Menu.Item>
        ) : null} */}

          {listPermissions.includes(PERMISSION.Admin_Product_View) ? (
            <Menu.Item key="product">
              <NavLink to="/product">
                <span
                  className="icon"
                  style={{
                    background: page === "product" ? color : "",
                  }}
                >
                  <AiOutlineDropbox />
                </span>
                <span className="label">Sản phẩm</span>
              </NavLink>
            </Menu.Item>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_ProductCategory_View) ? (
            <Menu.Item key="productCategory">
              <NavLink to="/product-category">
                <span
                  className="icon"
                  style={{
                    background: page === "product-category" ? color : "",
                  }}
                >
                  <BiCategoryAlt />
                </span>
                <span className="label">Danh mục</span>
              </NavLink>
            </Menu.Item>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Voucher_View) ? (
            <Menu.Item key="voucher">
              <NavLink to="/voucher">
                <span
                  className="icon"
                  style={{
                    background: page === "voucher" ? color : "",
                  }}
                >
                  <AiOutlinePercentage />
                </span>
                <span className="label">Mã giảm giá</span>
              </NavLink>
            </Menu.Item>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Promotion_View) ? (
            <Menu.Item key="promotion">
              <NavLink to="/promotion">
                <span
                  className="icon"
                  style={{
                    background: page === "promotion" ? color : "",
                  }}
                >
                  <FaBullhorn />
                </span>
                <span className="label">Khuyến mãi</span>
              </NavLink>
            </Menu.Item>
          ) : null}
        </Menu.SubMenu>

        {/* {listPermissions.includes("Admin.Article.View") ? (
          <Menu.Item className="menu-item-header" key="7">
            Bài Viết
          </Menu.Item>
        ) : null} */}
        <Menu.SubMenu
          className="menu-item-header"
          key="customer"
          title={<label>Khách hàng</label>}
        >
          {listPermissions.includes(PERMISSION.Admin_UserCustomer_View) ? (
            <Menu.Item key="userCustomer">
              <NavLink to="/user-customer">
                <span
                  className="icon"
                  style={{
                    background: page === "user-customer" ? color : "",
                  }}
                >
                  <AiOutlineUsergroupAdd />
                </span>
                <span className="label">Tài khoản</span>
              </NavLink>
            </Menu.Item>
          ) : null}
        </Menu.SubMenu>
        <Menu.SubMenu
          className="menu-item-header"
          key="article-page"
          title={<label>Bài Viết</label>}
        >
          {listPermissions.includes(PERMISSION.Admin_Blog_View) ? (
            <Menu.Item key="article">
              <NavLink to="/article">
                <span
                  className="icon"
                  style={{
                    background: page === "article" ? color : "",
                  }}
                >
                  <BiNews />
                </span>
                <span className="label">Bài viết</span>
              </NavLink>
            </Menu.Item>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_BlogCategory_View) ? (
            <Menu.Item key="articleCategory">
              <NavLink to="/article-category">
                <span
                  className="icon"
                  style={{
                    background: page === "article-category" ? color : "",
                  }}
                >
                  <BiCategoryAlt />
                </span>
                <span className="label">Chuyên mục</span>
              </NavLink>
            </Menu.Item>
          ) : null}
        </Menu.SubMenu>

        {/* <Menu.Item className="menu-item-header" key="systemUser">
          Hệ thống
        </Menu.Item> */}

        <Menu.SubMenu
          className="menu-item-header"
          key="systems"
          title={<label>Quản trị</label>}
        >
          {listPermissions.includes(PERMISSION.Admin_UserSystem_View) ? (
            <Menu.Item key="userSystem">
              <NavLink to="/user-system">
                <span
                  className="icon"
                  style={{
                    background: page === "user-system" ? color : "",
                  }}
                >
                  {profile}
                </span>
                <span className="label">Tài khoản quản trị</span>
              </NavLink>
            </Menu.Item>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Role_View) ? (
            <Menu.Item key="roleManager">
              <NavLink to="/role-manager">
                <span
                  className="icon"
                  style={{
                    background: page === "role-manager" ? color : "",
                  }}
                >
                  <AiOutlineUnlock />
                </span>
                <span className="label">Phân quyền</span>
              </NavLink>
            </Menu.Item>
          ) : null}
        </Menu.SubMenu>

        {listPermissions.includes(PERMISSION.Admin_Menu_View) ? (
          <Menu.SubMenu
            className="menu-item-header"
            key="menu"
            title={<label>Menu</label>}
          >
            <Menu.Item key="header">
              <NavLink to="/header">
                <span
                  className="icon"
                  style={{
                    background: page === "header" ? color : "",
                  }}
                >
                  <AiOutlineMenuFold />
                </span>
                <span className="label">Đầu trang</span>
              </NavLink>
            </Menu.Item>

            <Menu.Item key="footer">
              <NavLink to="/footer">
                <span
                  className="icon"
                  style={{
                    background: page === "footer" ? color : "",
                  }}
                >
                  <AiOutlineMenuFold />
                </span>
                <span className="label">Chân trang</span>
              </NavLink>
            </Menu.Item>
          </Menu.SubMenu>
        ) : null}

        <Menu.SubMenu
          className="menu-item-header"
          key="systemUser"
          title={<label>Hệ thống</label>}
        >
          {listPermissions.includes(PERMISSION.Admin_Shipping_View) ||
          listPermissions.includes(PERMISSION.Admin_Address_View) ? (
            <>
              <Menu.Item key="shipping">
                <NavLink to="/shipping">
                  <span
                    className="icon"
                    style={{
                      background: page === "shipping" ? color : "",
                    }}
                  >
                    <FaTruck />
                  </span>
                  <span className="label">Vận chuyển</span>
                </NavLink>
              </Menu.Item>
            </>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Payment_View) ? (
            <Menu.Item key="payments">
              <NavLink to="/payments">
                <span
                  className="icon"
                  style={{
                    background: page === "payments" ? color : "",
                  }}
                >
                  <FaRegCreditCard />
                </span>
                <span className="label">PT Thanh toán</span>
              </NavLink>
            </Menu.Item>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Newspapers_View) ? (
            <Menu.Item key="newspapers">
              <NavLink to="/newspapers">
                <span
                  className="icon"
                  style={{
                    background: page === "newspapers" ? color : "",
                  }}
                >
                  <BsNewspaper />
                </span>
                <span className="label">Báo Chí</span>
              </NavLink>
            </Menu.Item>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Advertising_View) ? (
            <Menu.Item key="ads">
              <NavLink to="/ads">
                <span
                  className="icon"
                  style={{
                    background: page === "ads" ? color : "",
                  }}
                >
                  <HiSpeakerphone />
                </span>
                <span className="label">CT Quảng Cáo</span>
              </NavLink>
            </Menu.Item>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Setting_View) ? (
            <>
              {" "}
              <Menu.Item key="home-modules">
                <NavLink to="/home-modules">
                  <span
                    className="icon"
                    style={{
                      background: page === "home-modules" ? color : "",
                    }}
                  >
                    <BiExtension />
                  </span>
                  <span className="label">Modules</span>
                </NavLink>
              </Menu.Item>
              <Menu.Item key="seo-modules">
                <NavLink to="/seo-modules">
                  <span
                    className="icon"
                    style={{
                      background: page === "seo-modules" ? color : "",
                    }}
                  >
                    <AiOutlineFileSearch />
                  </span>
                  <span className="label">Seo Modules</span>
                </NavLink>
              </Menu.Item>
            </>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Page_View) ? (
            <Menu.Item key="pager">
              <NavLink to="/page">
                <span
                  className="icon"
                  style={{
                    background: page === "page" ? color : "",
                  }}
                >
                  <BiFileBlank />
                </span>
                <span className="label">Trang động</span>
              </NavLink>
            </Menu.Item>
          ) : null}

          <Menu.Item key="dealer">
            <NavLink to="/dealer">
              <span
                className="icon"
                style={{
                  background: page === "dealer" ? color : "",
                }}
              >
                <AiFillShop />
              </span>
              <span className="label">Đại lý</span>
            </NavLink>
          </Menu.Item>

          {listPermissions.includes(PERMISSION.Admin_Setting_View) ? (
            <Menu.Item key="info">
              <NavLink to="/info">
                <span
                  className="icon"
                  style={{
                    background: page === "info" ? color : "",
                  }}
                >
                  <FaGlobe />
                </span>
                <span className="label">Website</span>
              </NavLink>
            </Menu.Item>
          ) : null}
          <Menu.Item key="info">
            <NavLink to="/sitemap">
              <span
                className="icon"
                style={{
                  background: page === "sitemap" ? color : "",
                }}
              >
                <FaSitemap />
              </span>
              <span className="label">Sitemap generate</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="file-manager">
            <NavLink to="/file-manager">
              <span
                className="icon"
                style={{
                  background: page === "file-manager" ? color : "",
                }}
              >
                <BsImages />
              </span>
              <span className="label">Quản lý media</span>
            </NavLink>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </>
  );
}

export default Sidenav;
